import ProfileDetailUserDataPushes from './ProfileDetailUserDataPushes';

export default ProfileDetailUserDataPushes;
